// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled[data-v-7381e72e] {\n  pointer-events:none;\n  color: #bfcbd9;\n  cursor: not-allowed;\n  background-image: none;\n  background-color: #eef1f6;\n  border-color: #d1dbe5;\n}\n", ""]);
// Exports
module.exports = exports;
